import router from "@/router/index";
// import store from "@/store";
import {message} from "ant-design-vue";

// 免登录名单
const whiteList = ['/welcome', '/login', '/content/edit', '/preview-content', '/preview-detail', '/operation-record'];

router.beforeEach(async (to, from, next) => {
  // console.log(to, from);
  next();
  /*if (store.state.token) {

    if (!store.getters.userInfoGetter.id) {
      await store.dispatch('GetUserInfo')
    }

    /!*if (whiteList.includes(to.path)) {
      next();
    }*!/

    if (store.getters.userInfoGetter && store.getters.userInfoGetter.functions && store.getters.userInfoGetter.functions.length >= 0) {
      let menus = store.getters.userInfoGetter.functions.map(x => {
        if (x.menuFlag === 1) {
          const {identity} = x;
          return {identity}
        }
      }).filter(d => d);

      if (whiteList.includes(to.path)) {
        next();
      }

      const permissionArr = [
        {
          name: 'userManage',
          alias: 'cmsUser',
        },
        {
          name: 'roleManage',
          alias: 'role',
        },
        {
          name: 'functionManage',
          alias: 'func',
        },
        {
          name: 'contentManage',
          alias: 'content',
        },
        {
          name: 'publicChannelManage',
          alias: 'publicChannel',
        },
        {
          name: 'publicUserManage',
          alias: 'publicUser',
        },
        {
          name: 'welcome',
          alias: 'welcome',
        },
      ];
      for (let item of permissionArr) {
        if (to.name === item.alias) {
          // console.log(to.name);
          for (let j of menus) {
            if (item.name === j.identity) {
              next()
            }
          }
        }
      }
    }

    next();
  } else {
    if (to.path === '/login') {
      // 免登录
      next();
    } else {
      next('/login'); // 重定向到登录页
    }
  }*/
});
